import type { BondRenderField } from "@/lib/bondFields";

/**
 * "Please complete:" and the fields a blocked save still needs.
 *
 * Its own module since BRK-S181, because it renders in two places now: at step
 * level for the fields that belong to no one card, and INSIDE an indemnitor
 * card for the fields that belong to that person — one component, so the two
 * cannot come to word the same refusal differently.
 */
export function BondMissingChecklist({
  missing,
}: {
  missing: readonly BondRenderField[];
}) {
  if (missing.length === 0) return null;
  return (
    <div
      role="alert"
      className="flex flex-col gap-1 rounded-md border border-brk-danger/40 bg-brk-danger/5 px-3 py-2 text-sm text-brk-text"
    >
      <p className="font-medium">Please complete:</p>
      <ul className="list-inside list-disc text-brk-dim">
        {missing.map((f) => (
          <li key={f.name}>{f.label}</li>
        ))}
      </ul>
    </div>
  );
}
